
import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import components from '@/components/message-items/require-all-msg-type.js';
import { DEFAULTAVATAR } from '@/utils/extuinInfo.js';
import QrCode from '@/components/QrCode/index.vue';

@Component({
  name: 'MessageItem',
  components: {
    ...components,
    QrCode,
  },
})

class MessageItem extends Vue {
  @Prop({ default: {} }) message:any;
  @Inject() MsgType:any;
  @Inject() IMSDKType:any;
  @Inject() MsgStatus:any;
  @Inject() inIframe: any;
  @Inject() globalData: any;
  get DEFAULTAVATAR() {
    return DEFAULTAVATAR;
  }

  get msg() {
    return this.message;
  }

  get msgType() {
    return '';
  }

  get msgId() {
    /* eslint-disable max-len */
    return this.msg?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.str_current_qidian_msg_unique_id;
  }

  get msgSendSuccess() {
    return this.msg.status === this.MsgStatus.Success;
  }
  // 消息是否能回复，只有当消息有id，并且消息的发送状态未发送成功才能发送
  get canReplay() {
    console.log(this.msgId, this.msgSendSuccess, 56765464654);
    return this.msgId && this.msgSendSuccess;
  }

  get msgCls() {
    const { msg, IMSDKType, MsgType } = this;

    // 非普通聊天消息
    const TYPE_TO_CLS = {
      [IMSDKType.MSG_GRAY]: 'msg-type-gray',
      [MsgType.MSG_TIP]: 'msg-type-tip',
      [MsgType.MSG_DATETIME]: 'msg-type-datetime',
      [IMSDKType.MSG_REVOKE]: 'msg-type-revoke',
      [IMSDKType.MSG_ROBOT_NAV]: 'msg-type-robot-nav',
    };
    if (msg.type in TYPE_TO_CLS) {
      return TYPE_TO_CLS[msg.type];
    }

    return `${msg.mine ? 'msg-c2b' : 'msg-b2c'} msg-type-${msg.type}`;
  }

  handleContextmenu(event) {
    const ALLOW_COPY_MSG_TYPES = [
      this.IMSDKType.MSG_TEXT,
      this.IMSDKType.MSG_LONG_MSG,
    ];
    // 如果消息不满足回复条件，则什么跳过
    if (!this.canReplay) {
      return;
    }
    event.preventDefault();
    const items = [
      { label: '回复', icon: 'replay', onClick: () => this.$emit('onReplay', this.msg) },
    ];
    if (ALLOW_COPY_MSG_TYPES.includes(this.msg.type)) {
      let text = '';
      if (this.msg.type === this.IMSDKType.MSG_TEXT) {
        text = this.msg.content;
      }
      if (this.msg.type === this.IMSDKType.MSG_LONG_MSG) {
        /* eslint-disable no-underscore-dangle */
        text = this.msg._processedText;
      }

      items.push({ label: '复制', icon: 'copy', onClick: () => this.$emit('onCopy', text) });
    } else if (this.msg.type === this.IMSDKType.MSG_MIX) {
      // 这里之所以在这里处理是因为如果消息本身是混合消息，过滤掉表情之后，文本为空，则不展示复制按钮（产品逻辑）
      let text = '';
      this.msg.content.forEach((item) => {
        if (item.type === this.IMSDKType.MSG_TEXT) {
          text += item.content;
        }
        if (item.type === this.IMSDKType.MSG_FACE) {
          text += '[表情]';
        }
      });
      if (text.trim().length > 0) {
        items.push({ label: '复制', icon: 'copy', onClick: () => this.$emit('onCopy', text) });
      }
    }
    this.$contextmenu({
      items,
      event,
      zIndex: 3,
      minWidth: 160,
    });
  }
  // 重发消息
  resendMsg() {
    this.$emit('resendMsg');
  }
}
export default MessageItem;
